/**
 * @file 回复mutaions
 */

export default {
    initReplyData(state, data) {
        state.replyData = Object.assign({}, data);
    },
    moreReplyData(state, data) {
        data.replyList1 = state.replyData.replyList1.concat(data.replyList1);
        state.replyData = data;
    },
    // 改变当前回复的标识
    addReplyIcon(state, {replyId, type}) {
        state.replyData.replyList1.forEach(list => {
            if (list.replyId === replyId) {
                if (type === 'accept') {
                    list.isAccepted = 1;
                }
                else if (type === 'recommend') {
                    list.isRecommended = 1;
                }
            }
            if (list.replyList2) {
                list.replyList2.forEach(item => {
                    if (item.replyId === replyId) {
                        if (type === 'accept') {
                            item.isAccepted = 1;
                        }
                        else if (type === 'recommend') {
                            item.isRecommended = 1;
                        }
                    }
                });
            }
        });
    },
    updateReplyLikeState(state, {replyId, isTop, hasTopReply}) {
        // 置顶区域需要同步回帖区的点赞态
        if (isTop) {
            state.replyData.replyList1.forEach(list => {
                if (list.replyId === replyId) {
                    list.isEvaluated = list.isEvaluated ? 0 : 1;
                    list.evaluationCount
                        = list.isEvaluated
                            ? list.evaluationCount + 1
                            : list.evaluationCount - 1;
                }
                list.replyList2.forEach(item => {
                    if (item.replyId === replyId) {
                        item.isEvaluated = item.isEvaluated ? 0 : 1;
                        item.evaluationCount
                            = item.isEvaluated
                                ? item.evaluationCount + 1
                                : item.evaluationCount - 1;
                    }
                });
            });
        }
        // 回帖区需要同步置顶区域的点赞态
        else if (hasTopReply) {
            if (state.topicData.ext.replyTopInfo.replyList[replyId]) {
                let list = state.topicData.ext.replyTopInfo.replyList[replyId];
                list.isEvaluated = list.isEvaluated ? 0 : 1;
                list.evaluationCount
                    = list.isEvaluated
                        ? list.evaluationCount + 1
                        : list.evaluationCount - 1;
            }
        }
    },
    updateReplyDeleteState(state, {replyId, hasTopReply}) {
        // 删帖后会重新拉取回复列表，所以置顶帖的删除不需要同步回复区
        // 回帖区需要同步置顶区域的删除态
        if (hasTopReply) {
            // 一级回复被删
            if (state.topicData.ext.replyTopInfo.replyList[replyId]) {
                // 单纯的 delete 不能触发 computed 属性
                let list = Object.assign({}, state.topicData.ext.replyTopInfo.replyList);
                delete list[replyId];
                state.topicData.ext.replyTopInfo.replyList = Object.assign({}, list);
            }

        }
    },
    changeReplyCount(state, count) {
        state.replyData.replyCount = count;
    },
    changeReplyList(state, list) {
        state.replyData.replyList = Object.assign({}, list);
    },
    changeTopAreaList(state, list) {
        state.topicData.ext.replyTopInfo.replyList = Object.assign({}, list);
    }
};
